const LOCAL_GATEWAY_URL = 'http://localhost:8070';
const DEV_GATEWAY_URL = 'https://devecmservices.vertexsmb.com';
const QA_GATEWAY_URL = 'https://qaecmservices.vertexsmb.com';
const MDU_GATEWAY_URL = 'https://mduecmservices.vertexsmb.com';
const STAGE_GATEWAY_URL = 'https://stageecmservices.vertexsmb.com';
const PROD_GATEWAY_URL = 'https://ecmservices.vertexsmb.com';
const CS_GATEWAY_URL = 'https://csecmservices.vertexsmb.com';

const GATEWAY_URL_MAP = new Map<string, string>();
GATEWAY_URL_MAP.set('http://localhost:8080', DEV_GATEWAY_URL);
GATEWAY_URL_MAP.set('https://devecmportal.vertexsmb.com', DEV_GATEWAY_URL);
GATEWAY_URL_MAP.set('https://qaecmportal.vertexsmb.com', QA_GATEWAY_URL);
GATEWAY_URL_MAP.set('https://mduecmportal.vertexsmb.com', MDU_GATEWAY_URL);
GATEWAY_URL_MAP.set('https://stageecmportal.vertexsmb.com', STAGE_GATEWAY_URL);
GATEWAY_URL_MAP.set('https://d12zmhy9cg9ffq.cloudfront.net', STAGE_GATEWAY_URL);
GATEWAY_URL_MAP.set('https://csecmportal.vertexsmb.com', CS_GATEWAY_URL);

export const GATEWAY_ENDPOINT = GATEWAY_URL_MAP.get(window.location.origin) || PROD_GATEWAY_URL;

// @TODO: Doing this for now so we don't have to rebuild per environment, need to rethink this
const DEV_AUTH_URL = 'https://devauth.vertexsmb.com';
const QA_AUTH_URL = 'https://qaauth.vertexsmb.com';
const MDU_AUTH_URL = 'https://qaauth.vertexsmb.com'; // MDU uses QA Auth
const STAGE_AUTH_URL = 'https://stageauth.vertexsmb.com';
const PROD_AUTH_URL = 'https://auth.vertexsmb.com';
const CS_AUTH_URL = 'https://csauth.vertexsmb.com';
const AUTH0_DEV_AUTH_URL = 'https://dev-auth.vtxdev.net';
const AUTH0_QA_AUTH_URL = 'https://qa-auth.vtxdev.net';
const AUTH0_STAGE_AUTH_URL = 'https://stage-auth.vertexcloud.com';
const AUTH0_PROD_AUTH_URL = 'https://auth.vertexcloud.com';
const AUTH0_CS_AUTH_URL = 'https://cs-auth.vertexcloud.com';

const AUTH_URL_MAP = new Map<string, string>();
AUTH_URL_MAP.set('http://localhost:8080', DEV_AUTH_URL);
AUTH_URL_MAP.set('https://devecmportal.vertexsmb.com', DEV_AUTH_URL);
AUTH_URL_MAP.set('https://qaecmportal.vertexsmb.com', QA_AUTH_URL);
AUTH_URL_MAP.set('https://mduecmportal.vertexsmb.com', MDU_AUTH_URL);
AUTH_URL_MAP.set('https://stageecmportal.vertexsmb.com', STAGE_AUTH_URL);
AUTH_URL_MAP.set('https://d12zmhy9cg9ffq.cloudfront.net', STAGE_AUTH_URL);
AUTH_URL_MAP.set('https://csecmportal.vertexsmb.com', CS_AUTH_URL);

const AUTH0_AUTH_URL_MAP = new Map<string, string>();
AUTH0_AUTH_URL_MAP.set('http://localhost:8080', AUTH0_DEV_AUTH_URL);
AUTH0_AUTH_URL_MAP.set('https://devecmportal.vertexsmb.com', AUTH0_DEV_AUTH_URL);
AUTH0_AUTH_URL_MAP.set('https://qaecmportal.vertexsmb.com', AUTH0_QA_AUTH_URL);
AUTH0_AUTH_URL_MAP.set('https://mduecmportal.vertexsmb.com', AUTH0_QA_AUTH_URL);
AUTH0_AUTH_URL_MAP.set('https://stageecmportal.vertexsmb.com', AUTH0_STAGE_AUTH_URL);
AUTH0_AUTH_URL_MAP.set('https://d12zmhy9cg9ffq.cloudfront.net', AUTH0_STAGE_AUTH_URL);
AUTH0_AUTH_URL_MAP.set('https://csecmportal.vertexsmb.com', AUTH0_CS_AUTH_URL);
AUTH0_AUTH_URL_MAP.set('https://ecmportal.vertexsmb.com', AUTH0_PROD_AUTH_URL);

const DEV_AUTH0_CLIENT_ID = 'OJiqSBZAsW7s8eJTawVVPGQmJqVri3jy';
const QA_AUTH0_CLIENT_ID = 'KJuu2FnI9LMZiRjt6ezqSholzP8u8bJo';
const STAGE_AUTH0_CLIENT_ID = 'tw1G0BRmhIxhE230ITS9WxTHTHpJr8ur';
const PROD_AUTH0_CLIENT_ID = 'eeoCj0Yi506iuEkboDANlfNHzkbkm4qC';
const CS_AUTH0_CLIENT_ID = 'AUTH0_NOT_DEPLOYED_IN_CS';

const AUTH0_CLIENT_ID_MAP = new Map<string, string>();
AUTH0_CLIENT_ID_MAP.set('http://localhost:8080', DEV_AUTH0_CLIENT_ID);
AUTH0_CLIENT_ID_MAP.set('https://devecmportal.vertexsmb.com', DEV_AUTH0_CLIENT_ID);
AUTH0_CLIENT_ID_MAP.set('https://qaecmportal.vertexsmb.com', QA_AUTH0_CLIENT_ID);
AUTH0_CLIENT_ID_MAP.set('https://mduecmportal.vertexsmb.com', QA_AUTH0_CLIENT_ID);
AUTH0_CLIENT_ID_MAP.set('https://stageecmportal.vertexsmb.com', STAGE_AUTH0_CLIENT_ID);
AUTH0_CLIENT_ID_MAP.set('https://d12zmhy9cg9ffq.cloudfront.net', PROD_AUTH0_CLIENT_ID);
AUTH0_CLIENT_ID_MAP.set('https://csecmportal.vertexsmb.com', CS_AUTH0_CLIENT_ID);
AUTH0_CLIENT_ID_MAP.set('https://ecmportal.vertexsmb.com', PROD_AUTH0_CLIENT_ID);
export const AUTH0_CLIENT_ID = AUTH0_CLIENT_ID_MAP.get(window.location.origin) || PROD_AUTH0_CLIENT_ID;

const nonce = Math.random().toString(36).substring(7);
const redirectUri = window.location.origin;

export const AUTH_URL = AUTH_URL_MAP.get(window.location.origin) || PROD_AUTH_URL;
export const AUTH0_AUTH_URL = AUTH0_AUTH_URL_MAP.get(window.location.origin) || AUTH0_PROD_AUTH_URL;

const DEV_WIZARD_SETTINGS_URL = 'https://devecwportal.vertexsmb.com';
const QA_WIZARD_SETTINGS_URL = 'https://qaecwportal.vertexsmb.com';
const MDU_WIZARD_SETTINGS_URL = 'https://mduecwportal.vertexsmb.com';
const STAGE_WIZARD_SETTINGS_URL = 'https://stageecwportal.vertexsmb.com';
const PROD_WIZARD_SETTINGS_URL = 'https://ecwportal.vertexsmb.com';
const CS_WIZARD_SETTINGS_URL = 'https://csecwportal.vertexsmb.com';

const WIZARD_SETTINGS_URL_MAP = new Map<string, string>();
WIZARD_SETTINGS_URL_MAP.set('http://localhost:8080', DEV_WIZARD_SETTINGS_URL);
WIZARD_SETTINGS_URL_MAP.set('https://devecmportal.vertexsmb.com', DEV_WIZARD_SETTINGS_URL);
WIZARD_SETTINGS_URL_MAP.set('https://qaecmportal.vertexsmb.com', QA_WIZARD_SETTINGS_URL);
WIZARD_SETTINGS_URL_MAP.set('https://mduecmportal.vertexsmb.com', MDU_WIZARD_SETTINGS_URL);
WIZARD_SETTINGS_URL_MAP.set('https://stageecmportal.vertexsmb.com', STAGE_WIZARD_SETTINGS_URL);
WIZARD_SETTINGS_URL_MAP.set('https://d12zmhy9cg9ffq.cloudfront.net', STAGE_WIZARD_SETTINGS_URL);
WIZARD_SETTINGS_URL_MAP.set('https://csecmportal.vertexsmb.com', CS_WIZARD_SETTINGS_URL);

export const WIZARD_SETTINGS_ENDPOINT = WIZARD_SETTINGS_URL_MAP.get(window.location.origin) || PROD_WIZARD_SETTINGS_URL;

export const LOGIN_URL: string = [
  AUTH_URL,
  '/identity/connect/authorize',
  '?response_type=id_token%20token',
  '&client_id=ecw-portal',
  `&redirect_uri=${redirectUri}/`,
  '&scope=openid%20profile%20vtms-internal-api%20ecw-api',
  `&state=af0ifjsldkj&nonce=${nonce}`].join('');

// This is the Url the Token Refresh IFrame will Open
export const TOKEN_REFRESH_URL = '/token/index.html'; // External Pages

// This is the Url the Token Refresh IFrame will redirect to
export const TOKEN_REQUEST_URL: string = [
  AUTH_URL,
  '/identity/connect/authorize',
  '?response_type=id_token%20token',
  '&client_id=ecw-portal',
  `&redirect_uri=${redirectUri}/token/result/index.html`,
  '&scope=openid%20profile%20vtms-internal-api%20ecw-api',
  '&state=af0ifjsldkj',
  `&nonce=${nonce}`].join('');

const DEV_LAUNCH_DARKLY_KEY = '61b03dd62733330d65a4c99e';
const QA_LAUNCH_DARKLY_KEY = '61b118738ac5a00e8179c970';
const STAGE_LAUNCH_DARKLY_KEY = '61b118928ac5a00e8179c97f';
const PROD_LAUNCH_DARKLY_KEY = '61af6dbc4eb8ad0d741dedd9';

const LAUNCH_DARKLY_KEY_MAP = new Map<string, string>();
LAUNCH_DARKLY_KEY_MAP.set('http://localhost:8080', DEV_LAUNCH_DARKLY_KEY);
LAUNCH_DARKLY_KEY_MAP.set('https://devecmportal.vertexsmb.com', DEV_LAUNCH_DARKLY_KEY);
LAUNCH_DARKLY_KEY_MAP.set('https://qaecmportal.vertexsmb.com', QA_LAUNCH_DARKLY_KEY);
LAUNCH_DARKLY_KEY_MAP.set('https://stageecmportal.vertexsmb.com', STAGE_LAUNCH_DARKLY_KEY);
LAUNCH_DARKLY_KEY_MAP.set('https://d12zmhy9cg9ffq.cloudfront.net', STAGE_LAUNCH_DARKLY_KEY);
LAUNCH_DARKLY_KEY_MAP.set('https://csecmportal.vertexsmb.com', STAGE_LAUNCH_DARKLY_KEY);

export const LAUNCH_DARKLY_KEY = LAUNCH_DARKLY_KEY_MAP.get(window.location.origin) || PROD_LAUNCH_DARKLY_KEY;

export default {
  AUTH_URL,
  GATEWAY_ENDPOINT,
};

// eslint-disable-next-line no-console
console.log('Starting ECM UI:', new Date());
